module.exports = __webpack_public_path__ + "media/img/user-6bd4263915f540cc26aa2542d31cdc54.png";